var _ellipse, _g, _path, _g2, _path2, _path3, _path4, _path5, _g3, _g4, _g5, _path6, _path7, _path8, _path9, _g6, _g7, _g8, _path10, _g9, _g10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHireMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 316,
    height: 204,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.5,
    cy: 192.146,
    fill: "#E1E1E1",
    rx: 47.256,
    ry: 3.78
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#706F6F",
    d: "M191.947 14.465h-58.893c-7.517 0-13.622 6.108-13.622 13.63v150.382c0 7.521 6.105 13.629 13.622 13.629h58.851c7.517 0 13.623-6.108 13.623-13.629V28.094c.041-7.52-6.064-13.63-13.581-13.63Zm13.207 163.929c0 7.355-5.981 13.338-13.332 13.338h-58.643c-7.352 0-13.332-5.983-13.332-13.338V28.219c0-7.355 5.98-13.339 13.332-13.339h58.643c7.351 0 13.332 5.984 13.332 13.34v150.174Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M191.697 191.192h-58.394c-7.06 0-12.833-5.734-12.833-12.84V28.219c0-7.064 5.731-12.84 12.833-12.84h58.394c7.061 0 12.834 5.734 12.834 12.84v150.133c0 7.106-5.773 12.84-12.834 12.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M184.969 18.246h6.77c5.524 0 10.009 4.488 10.009 10.015v150.091c0 5.526-4.485 10.014-10.009 10.014h-58.477c-5.524 0-10.01-4.488-10.01-10.014V28.261c0-5.527 4.486-10.015 10.01-10.015h51.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M206.483 59.674h-.499v21.525h.499V59.674Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M206.483 81.157V59.633l.249.29c-.125 2.286-.125 18.658 0 20.944l-.249.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M118.684 55.147h-.291v13.629h.291v-13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M118.393 68.776v-13.63l-.124.167c.083 1.454.083 11.843 0 13.255l.124.208Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M119.016 55.147h-.332v13.629h.332v-13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M118.684 72.266h-.291v13.63h.291v-13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M118.393 85.895v-13.63l-.124.208c.083 1.455.083 11.843 0 13.256l.124.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M119.016 72.266h-.332v13.63h.332v-13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M118.684 42.264h-.291v6.98h.291v-6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M118.393 49.245v-6.981l-.124.166c.083 1.371.083 5.277 0 6.648l.124.167Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M119.016 42.264h-.332v6.98h.332v-6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M169.062 26.556h-13.871a2.828 2.828 0 0 1-2.825-2.826 2.828 2.828 0 0 1 2.825-2.826h13.913a2.828 2.828 0 0 1 2.824 2.826c-.042 1.537-1.288 2.826-2.866 2.826Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M168.273 24.935a1.246 1.246 0 1 0 0-2.493 1.246 1.246 0 0 0 0 2.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M167.107 22.523h2.492v2.493h-2.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M168.273 24.395a.706.706 0 1 0 0-1.412.706.706 0 0 0 0 1.412Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M168.896 23.688a.64.64 0 0 1-.623.623.64.64 0 0 1-.623-.623.64.64 0 0 1 .623-.623c.374.041.623.29.623.623Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M168.896 23.688a.64.64 0 0 1-.623.623.64.64 0 0 1-.623-.623.64.64 0 0 1 .623-.623c.374.041.623.29.623.623Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M168.854 24.02c0-.124-.083-.207-.207-.207-.125 0-.208.083-.208.207 0 .125.083.208.208.208.083 0 .207-.083.207-.208Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4E4E",
    d: "M149.228 94.665v8.407h-1.379v-3.677h-3.956v3.677h-1.379v-8.407h1.379v3.604h3.956v-3.605h1.379Zm2.518.858a.857.857 0 0 1-.63-.254.856.856 0 0 1-.254-.629c0-.25.085-.46.254-.629.17-.17.38-.254.63-.254.241 0 .447.085.617.254.169.17.254.38.254.63s-.085.459-.254.628a.842.842 0 0 1-.617.254Zm.677.883v6.666h-1.379v-6.666h1.379Zm3.19.968c.201-.338.468-.6.798-.786.339-.194.738-.29 1.198-.29v1.427h-.351c-.54 0-.952.137-1.234.412-.274.274-.411.75-.411 1.427v3.508h-1.379v-6.666h1.379v.968Zm9.373 2.202c0 .25-.016.476-.049.678h-5.093c.041.532.238.959.593 1.282.355.322.791.484 1.307.484.742 0 1.266-.311 1.572-.932h1.488a3.018 3.018 0 0 1-1.1 1.512c-.525.388-1.178.581-1.96.581a3.48 3.48 0 0 1-1.718-.423 3.177 3.177 0 0 1-1.186-1.21c-.282-.524-.423-1.129-.423-1.815 0-.685.137-1.286.411-1.802a2.976 2.976 0 0 1 1.174-1.21c.508-.282 1.088-.423 1.742-.423.629 0 1.189.137 1.681.41.492.275.875.662 1.15 1.162.274.492.411 1.06.411 1.706Zm-1.44-.435c-.008-.509-.189-.916-.544-1.222-.355-.307-.795-.46-1.319-.46-.476 0-.883.153-1.222.46-.338.298-.54.705-.605 1.222h3.69Zm7.307-4.477v5.36c0 .637.165 1.117.496 1.439.338.323.806.484 1.403.484.605 0 1.073-.161 1.403-.484.339-.322.508-.802.508-1.439v-5.36h1.379V100c0 .686-.149 1.267-.447 1.743-.299.475-.698.83-1.198 1.064a3.86 3.86 0 0 1-1.657.351 3.864 3.864 0 0 1-1.658-.351 2.72 2.72 0 0 1-1.173-1.064c-.29-.476-.436-1.057-.436-1.743v-5.334h1.38Zm9.405 8.517c-.525 0-.996-.093-1.416-.278a2.57 2.57 0 0 1-.98-.774 1.96 1.96 0 0 1-.387-1.101h1.428a1 1 0 0 0 .399.714c.25.185.56.278.931.278.388 0 .686-.073.896-.218.217-.153.326-.347.326-.581 0-.25-.121-.435-.363-.556-.234-.121-.609-.254-1.125-.399-.5-.137-.907-.27-1.222-.4a2.195 2.195 0 0 1-.822-.592c-.226-.267-.339-.617-.339-1.053 0-.355.105-.677.315-.968.209-.298.508-.532.895-.701a3.41 3.41 0 0 1 1.355-.254c.758 0 1.367.193 1.826.58.468.38.718.9.751 1.56h-1.38a.981.981 0 0 0-.363-.713c-.217-.177-.512-.266-.883-.266-.363 0-.641.069-.834.206a.636.636 0 0 0-.291.544.59.59 0 0 0 .194.448c.129.12.286.217.472.29.185.064.459.15.822.254.484.13.879.262 1.186.4.314.128.585.322.81.58.226.258.343.601.351 1.028 0 .379-.105.718-.314 1.016-.21.299-.508.533-.896.702-.379.169-.826.254-1.342.254Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#s)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69.122,
    cy: 175.512,
    r: 18.902,
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D8FF",
    d: "M69.142 177.803a2.088 2.088 0 1 0 0-4.175 2.088 2.088 0 0 0 0 4.175Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D8FF",
    fillRule: "evenodd",
    d: "M59.22 174.49c-.494.446-.686.861-.686 1.226s.192.78.685 1.226c.494.445 1.241.874 2.215 1.246 1.944.742 4.669 1.214 7.708 1.214 3.04 0 5.765-.472 7.709-1.214.974-.372 1.72-.801 2.214-1.246.494-.446.685-.861.685-1.226s-.191-.78-.685-1.226c-.493-.445-1.24-.874-2.214-1.246-1.944-.742-4.67-1.214-7.709-1.214-3.04 0-5.764.472-7.708 1.214-.974.372-1.721.801-2.215 1.246Zm1.792-2.352c2.11-.806 4.984-1.292 8.13-1.292 3.146 0 6.021.486 8.13 1.292 1.054.402 1.947.895 2.587 1.473.64.578 1.075 1.288 1.075 2.105 0 .816-.436 1.527-1.075 2.105-.64.578-1.533 1.071-2.586 1.473-2.11.806-4.985 1.292-8.13 1.292-3.147 0-6.022-.486-8.131-1.292-1.053-.402-1.946-.895-2.586-1.473-.64-.578-1.075-1.289-1.075-2.105 0-.817.435-1.527 1.075-2.105.64-.578 1.533-1.071 2.586-1.473Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D8FF",
    fillRule: "evenodd",
    d: "M65.242 166.505c-.633-.205-1.088-.163-1.404.019-.316.183-.58.556-.718 1.206-.14.651-.137 1.512.028 2.542.33 2.055 1.284 4.651 2.805 7.284 1.52 2.633 3.291 4.758 4.906 6.071.81.658 1.554 1.091 2.187 1.296.632.205 1.088.163 1.403-.02.316-.182.58-.555.719-1.206.139-.65.136-1.511-.029-2.541-.33-2.055-1.284-4.651-2.804-7.285-1.52-2.633-3.292-4.758-4.907-6.07-.809-.658-1.553-1.091-2.186-1.296Zm2.933.377c1.753 1.425 3.612 3.672 5.185 6.398 1.574 2.725 2.59 5.458 2.948 7.689.179 1.113.198 2.133.018 2.976-.18.843-.578 1.576-1.285 1.984-.707.408-1.54.386-2.36.12-.82-.265-1.694-.792-2.569-1.503-1.752-1.425-3.611-3.672-5.185-6.398-1.573-2.725-2.59-5.458-2.948-7.689-.178-1.113-.197-2.133-.017-2.977.18-.843.577-1.575 1.284-1.983.707-.408 1.54-.386 2.36-.121.82.266 1.694.793 2.57 1.504Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D8FF",
    fillRule: "evenodd",
    d: "M75.165 167.732c-.14-.65-.403-1.024-.719-1.206-.316-.182-.77-.224-1.403-.019-.633.204-1.378.638-2.187 1.295-1.614 1.313-3.385 3.438-4.905 6.072-1.52 2.633-2.474 5.23-2.803 7.285-.165 1.03-.168 1.891-.029 2.542.14.65.403 1.024.72 1.206.315.182.77.224 1.403.02.632-.205 1.377-.638 2.186-1.296 1.614-1.313 3.385-3.438 4.905-6.071 1.52-2.634 2.474-5.231 2.803-7.286.165-1.03.168-1.891.029-2.542Zm1.14 2.729c-.357 2.231-1.374 4.965-2.947 7.691-1.573 2.725-3.431 4.973-5.184 6.398-.874.711-1.748 1.238-2.568 1.503-.82.266-1.653.288-2.36-.12-.707-.409-1.104-1.141-1.284-1.984-.18-.844-.161-1.864.017-2.977.358-2.231 1.374-4.965 2.947-7.691 1.573-2.725 3.431-4.973 5.184-6.398.874-.711 1.748-1.238 2.568-1.503.82-.266 1.653-.288 2.36.12.707.409 1.104 1.141 1.284 1.985.18.843.161 1.863-.017 2.976Z",
    clipRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#t)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240.756,
    cy: 25.805,
    r: 18.902,
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M245.839 25.922c-.008-1.424.658-2.5 2.009-3.292-.756-1.044-1.897-1.619-3.403-1.731-1.426-.11-2.985.803-3.556.803-.602 0-1.984-.765-3.069-.765-2.242.035-4.625 1.728-4.625 5.172 0 1.017.193 2.067.579 3.152.514 1.425 2.37 4.92 4.307 4.86 1.012-.022 1.727-.694 3.045-.694 1.278 0 1.94.695 3.069.695 1.953-.027 3.632-3.203 4.122-4.632-2.619-1.192-2.478-3.494-2.478-3.568Zm-2.274-6.375c1.097-1.257.996-2.403.964-2.815-.968.055-2.089.637-2.728 1.355-.702.77-1.117 1.72-1.028 2.792 1.048.078 2.005-.443 2.792-1.332Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#v)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.049,
    cy: 25.805,
    r: 18.902,
    fill: "#fff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#40D0FD",
    d: "m69.73 27.071 2.16-2.132h5.363L72.5 29.756 69.73 27.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#41D0FD",
    d: "m63 25.644 2.698 2.8 11.555-11.811h-5.364L63 25.643Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1FBCFD",
    d: "m67.027 29.781 2.736 2.732 2.738-2.759-2.771-2.684-2.703 2.711Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#095A9D",
    d: "m69.764 32.513 2.738-2.76 4.684 4.803h-5.394l-2.028-2.043Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#w)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.902,
    cy: 100.535,
    r: 18.902,
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#87C527",
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.75 92.527a5.274 5.274 0 0 1 2.319-1.314 5.273 5.273 0 0 1 2.664-.021l.395-.684a.379.379 0 0 1 .655.378l-.317.55a5.288 5.288 0 0 1 3.09 3.522L20.323 97.7a5.288 5.288 0 0 1 .915-4.596l-.55-.317a.378.378 0 0 1 .379-.655l.684.395Zm1.64 2.001a.757.757 0 1 1-1.461.392.757.757 0 0 1 1.461-.392Zm3.85-.248a.757.757 0 1 0-.391-1.462.757.757 0 0 0 .392 1.462Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.89 100.311a1.135 1.135 0 1 1 2.192-.587l1.175 4.385a1.135 1.135 0 1 1-2.193.587l-1.174-4.385ZM25.258 107.346l.685 2.558a1.135 1.135 0 0 0 2.193-.588l-.686-2.558 1.462-.392.686 2.558a1.135 1.135 0 1 0 2.192-.587l-.685-2.558.73-.196a1.513 1.513 0 0 0 1.07-1.853l-2.154-8.04-10.232 2.742 2.154 8.039a1.512 1.512 0 0 0 1.854 1.07l.73-.195ZM31.776 96.59a1.135 1.135 0 1 1 2.193-.587l1.175 4.385a1.135 1.135 0 1 1-2.193.588l-1.175-4.385Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#y)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 288.902,
    cy: 89.535,
    r: 18.902,
    fill: "#fff"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3880FF",
    d: "M289.012 79.633c1.623 0 3.151.38 4.585 1.114l.19.094-.166.13c-.403.32-.723.736-.924 1.21l-.06.13-.118-.06a8.111 8.111 0 0 0-3.495-.793c-4.515 0-8.176 3.673-8.176 8.175 0 4.502 3.65 8.175 8.164 8.175 4.514 0 8.175-3.673 8.175-8.175a7.882 7.882 0 0 0-.628-3.128l-.059-.13.13-.06a3.159 3.159 0 0 0 1.256-.853l.131-.166.082.19A9.827 9.827 0 0 1 299 89.61c0 5.51-4.491 10-10 10s-10-4.49-10-10 4.491-10 10.012-9.976Zm0 5.45c2.5 0 4.55 2.038 4.561 4.562a4.555 4.555 0 0 1-4.561 4.561 4.556 4.556 0 0 1-4.562-4.561 4.564 4.564 0 0 1 4.562-4.562Zm6.528-3.767a2.086 2.086 0 1 1 0 4.17 2.086 2.086 0 0 1 0-4.17Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#z)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250.902,
    cy: 160.535,
    r: 18.902,
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3498DB",
    fillRule: "evenodd",
    d: "M251.655 150.674a1.597 1.597 0 0 0-1.536-.019l-7.229 4.062a1.515 1.515 0 0 0-.753 1.303l.098 8.29c.008.529.317 1.052.785 1.322l7.325 4.229a1.597 1.597 0 0 0 1.536.018l7.228-4.06c.459-.261.757-.775.753-1.303l-.096-8.291a1.59 1.59 0 0 0-.785-1.321l-7.326-4.23Zm-2.019 3.651a.15.15 0 0 1 .03.018l1.264.73a.192.192 0 0 1 .093.158l.002 4.945a.178.178 0 0 1-.014.072.176.176 0 0 1 .054-.048l4.279-2.474a.19.19 0 0 1 .189.004l1.263.729c.112.066.117.251.009.317l-4.189 2.425-.001 4.835c.002.13-.168.223-.281.156l-1.264-.73a.193.193 0 0 1-.095-.166l.003-4.942a.178.178 0 0 1 .014-.072.176.176 0 0 1-.054.048l-4.285 2.47a.189.189 0 0 1-.187.004l-1.262-.729c-.115-.064-.119-.258-.006-.321l4.187-2.419.004-4.84c.001-.117.135-.21.247-.17Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 118.341,
    x2: 118.341,
    y1: 72.282,
    y2: 85.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 118.86,
    x2: 118.86,
    y1: 85.912,
    y2: 72.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 206.621,
    x2: 206.621,
    y1: 59.665,
    y2: 81.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 118.559,
    x2: 118.559,
    y1: 55.132,
    y2: 68.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#896E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#704A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 118.341,
    x2: 118.341,
    y1: 55.136,
    y2: 68.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 118.86,
    x2: 118.86,
    y1: 68.766,
    y2: 55.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 118.559,
    x2: 118.559,
    y1: 72.279,
    y2: 85.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#896E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#704A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 206.239,
    x2: 206.239,
    y1: 59.659,
    y2: 81.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#896E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#2B1D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#704A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#2B1D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 118.559,
    x2: 118.559,
    y1: 42.253,
    y2: 49.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#896E80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#704A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 118.341,
    x2: 118.341,
    y1: 42.257,
    y2: 49.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#786F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#654E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 118.86,
    x2: 118.86,
    y1: 49.253,
    y2: 42.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68595F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#5E3B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#2D1E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 168.287,
    x2: 168.287,
    y1: 24.864,
    y2: 22.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 168.287,
    x2: 168.287,
    y1: 23.043,
    y2: 24.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B131C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 168.723,
    x2: 167.849,
    y1: 24.142,
    y2: 23.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#222326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#1F2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#1A3D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#13537C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0B71AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#0094EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#0095EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0488D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#0D689F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#154E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912,
    stopColor: "#1B394E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#1F2B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#222225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    width: 52.927,
    height: 52.927,
    x: 0.439,
    y: 75.584,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1139_7054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1139_7054",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "y",
    width: 52.927,
    height: 52.927,
    x: 262.439,
    y: 64.584,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1139_7054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1139_7054",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "z",
    width: 52.927,
    height: 52.927,
    x: 224.439,
    y: 135.584,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1139_7054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1139_7054",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    width: 52.927,
    height: 52.927,
    x: 42.659,
    y: 150.561,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1139_7054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1139_7054",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "v",
    width: 52.927,
    height: 52.927,
    x: 44.586,
    y: 0.854,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1139_7054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1139_7054",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    width: 52.927,
    height: 52.927,
    x: 214.293,
    y: 0.854,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1139_7054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1139_7054",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M118.269 14.463h88.463v177.683h-88.463z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M233.195 16.732h15.122v17.39h-15.122z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.787 92.154 23.388-6.266 6.267 23.387-23.388 6.267z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m246.658 147.789 17.32 10-8.636 14.959-17.32-10z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.61783 0 0 .61815 168.287 23.704)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#175168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#0D78A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#0695CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#02A7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#02A6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#0693C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#0E749C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#184A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.22062 0 0 .22073 168.626 24.027)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.024,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "n",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    transform: "scale(.16667)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHZJREFUeNokjVEKwkAMRCehJJhk/bU3kH6q9z9Ai4fZTwtu12ydEBhmwgvdl6XXWqGiMDdEFLy3leg2zx0pUYW7D3uW0wgop1wL7GJgZrTjwBQR55WZo6QnYuz7B+z+L0QkN3FmaK0lI/V4vrom8pvB0Hj+E2AA+OYZu5x0xPUAAAAASUVORK5CYII=",
    id: "B",
    width: 6,
    height: 6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHireMobile);
export default __webpack_public_path__ + "static/media/HireMobile.b0938e9c6ba21979eb72c6c9210a1106.svg";
export { ForwardRef as ReactComponent };